import React from "react";
import {useTranslation} from "react-i18next";

type Props = {
    message: string
};

export const ErrorView: React.FC<Props> = ({
                                               message
                                           }) => {
    const {t} = useTranslation();
    return (<p>{t(message)}</p>)
}